export const refs = {
  searchForm: document.querySelector('#search-form'),
  btnSearch: document.querySelector('[type="submit"]'),
  galleryContainer: document.querySelector('.gallery'),
  loader: document.querySelector('#loading'),
  btnUp: document.querySelector('#back-top'),
};
